import styled from 'styled-components';
import { PenLine } from 'lucide-react';
import { text, colors, ui } from '@annote/core/styles';

const AnnotesInfo = styled.div`
  color: ${colors.text.description};
  font-family: ${text.family.primary};
  font-size: ${text.size.small};
  font-style: normal;
  font-weight: 500;
  line-height: 2rem;

  display: flex;
  padding: 0.375rem 0.75rem;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.5rem;
  background: ${colors.bg.quote.primary};
`;

const NumberOfAnnotes: React.FC<{ annoteCount: number }> = ({ annoteCount }) => (
  <AnnotesInfo>
    <PenLine size={ui.getIconSize('cardButton')} /> {annoteCount}
  </AnnotesInfo>
);

export default NumberOfAnnotes;
